import React, { createContext, useReducer } from 'react';
import reducer, { AppState, initialState } from '../store';
import ModalWrapperComponent from '../components/shared/Modals/ModalWrapperComponent';
import { Session } from '../types/Session';

export const AppAgentContext = createContext<{
    state: AppState;
    dispatch: React.Dispatch<any>;
}>({
    state: initialState,
    dispatch: () => null,
});


export const AppProvider = (props: { children: React.ReactNode, session: Session }) => {

    const [state, dispatch] = useReducer(reducer, { ...initialState, session: props.session });

    return (
        <AppAgentContext.Provider
            value={{ state, dispatch }}
        >
            {props.children}
            <ModalWrapperComponent />
        </AppAgentContext.Provider>
    );
};